import ReducerRegistry from '../base/redux/ReducerRegistry';
import { CLOSE_LOGIN_MODAL, OPEN_LOGIN_MODAL, RESET_AUTH, SET_AUTHENTICATED, SET_AUTH_ERROR, SET_AUTH_LOADING, SET_AUTH_STEP, SET_OTP, SET_PENDING_ROOM, SET_PHONE_NUMBER, SET_USERNAME, SET_USER_INFO } from './actionTypes';
const DEFAULT_STATE = {
    step: 'phone',
    phoneNumber: '',
    otp: '',
    username: '',
    loading: false,
    error: null,
    isAuthenticated: false,
    userInfo: null,
    isLoginModalOpen: false,
    pendingRoom: null
};
ReducerRegistry.register('features/auth', (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case SET_AUTH_STEP:
            return {
                ...state,
                step: action.step,
                error: null
            };
        case SET_PHONE_NUMBER:
            return {
                ...state,
                phoneNumber: action.phoneNumber
            };
        case SET_OTP:
            return {
                ...state,
                otp: action.otp
            };
        case SET_USERNAME:
            return {
                ...state,
                username: action.username
            };
        case SET_AUTH_LOADING:
            return {
                ...state,
                loading: action.loading
            };
        case SET_AUTH_ERROR:
            return {
                ...state,
                error: action.error,
                // Only set loading to false when there's an actual error
                ...(action.error !== null ? { loading: false } : {})
            };
        case SET_AUTHENTICATED:
            return {
                ...state,
                isAuthenticated: action.isAuthenticated
            };
        case SET_USER_INFO:
            return {
                ...state,
                userInfo: action.userInfo
            };
        case RESET_AUTH:
            return {
                ...DEFAULT_STATE,
                isLoginModalOpen: state.isLoginModalOpen,
                pendingRoom: state.pendingRoom
            };
        case OPEN_LOGIN_MODAL:
            return {
                ...state,
                isLoginModalOpen: true,
                pendingRoom: action.pendingRoom,
                step: 'phone',
                error: null
            };
        case CLOSE_LOGIN_MODAL:
            return {
                ...state,
                isLoginModalOpen: false,
                pendingRoom: null,
                step: 'phone',
                error: null,
                otp: '',
                phoneNumber: ''
            };
        case SET_PENDING_ROOM:
            return {
                ...state,
                pendingRoom: action.room
            };
        default:
            return state;
    }
});
